import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, PopoverController, LoadingController, AlertController, ModalController, ToastController } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
import * as moment from 'moment';
import * as _ from 'lodash';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/mergeMap';
import { Chart } from 'chart.js';

import { PatientAddPage } from '../patient-add/patient-add';
import { DatabaseProvider } from '../../providers/database/database';
import { UtilityProvider } from '../../providers/utility/utility';

@IonicPage()
@Component({
    selector: 'page-home',
    templateUrl: 'home.html',
})
export class HomePage {

    @ViewChild('ytdStatusCanvas') ytdStatusCanvas;
    ytdStatusPie: any;

    @ViewChild('ytdCCCanvas') ytdCCCanvas;
    ytdCCPie: any;

    @ViewChild('barCanvas') barCanvas;
    barChart: any;

    message: string;
    toastBackground: string = null;
    clinic_name: string = null;
    clinic_id: string = null;
    public studyList: Observable<any[]>;
    public prescriptionList: Observable<any[]>;
    public patientStudy: Observable<any[]>;
    studyinfo: any;

    rx: any[] = [];

    eylea_pfs_count: number;
    eylea_vial_count: number;
    lucentis_count: number;
    ozurdex_count: number;
    avastin_count: number;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public popoverCtrl: PopoverController,
        public loadingCtrl: LoadingController,
        public modalCtrl: ModalController,
        public alertCtrl: AlertController,
        public toastCtrl: ToastController,
        private readonly auth: AuthProvider,
        public database: DatabaseProvider,
        private utility: UtilityProvider
    ) { 
      this.auth.getCurrentUser().then(user => {
        this.clinic_name = user.clinic_name;
        this.clinic_id =  user.clinic_id;
        console.log(this.clinic_id);

        this.database.getOrdersbyClinic(this.clinic_id)
        .snapshotChanges()
        .map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            data.id = a.payload.doc.id;
            return data;
          });
        }).subscribe(async (res) => {
          let totalrx = [];
          await this.utility.asyncForEach(res, async (order) => {
            if(order) {
              // console.log('batch: ', order.rx);
              await this.utility.asyncForEach(order.rx, async (rxarray) => {
                totalrx.push(...rxarray.rx)
              });
            }
          });
          console.log('RX array: ', totalrx);
          const totalrx_createddate = totalrx.filter(t => t.createdAt)
          totalrx_createddate.forEach(element => {
            element['month'] = moment.unix(element.createdAt.seconds).format('MMMM');
            console.log(element);
          });
          
          // const grouped = _.groupBy(totalrx_createddate, rx => rx.createdAt.toDate());
          // console.log('Meds: ', grouped)
          this.eylea_pfs_count = totalrx.filter(t => t.medication === 'Eylea PFS' && t.eye === 'OS').length + totalrx.filter(t => t.medication === 'Eylea PFS' && t.eye === 'OD').length + (totalrx.filter(t => t.medication === 'Eylea PFS' && t.eye === 'OU').length)*2;
          this.eylea_vial_count = totalrx.filter(t => t.medication === 'Eylea vial').length;
          this.lucentis_count = totalrx.filter(t => t.medication === 'Lucentis').length;
          this.ozurdex_count = totalrx.filter(t => t.medication === 'Ozurdex').length;
          this.avastin_count = totalrx.filter(t => t.medication === 'Avastin').length;
          const totalCount = this.eylea_pfs_count + this.eylea_vial_count + this.lucentis_count + this.ozurdex_count + this.avastin_count;
          console.log('Eylea PFS: ', this.eylea_pfs_count);
          console.log('Eylea vial: ', this.eylea_vial_count);
          console.log('Lucentis: ', this.lucentis_count);
          console.log('Ozurdex: ', this.ozurdex_count);
          console.log('Avastin: ', this.avastin_count);
          console.log('total count: ', totalCount);
        });
      })

    }

    ionViewDidLoad() {}

    ionViewWillEnter() {}

    goPatient() {
        this.navCtrl.push(PatientAddPage);
    }

    onStorageUrlEmitted(ev) {
      console.log(ev)
    }
    

  public formatDate(date) {
    let myMoment: moment.Moment
    if (date.seconds) {
      myMoment = moment.unix(date.seconds);
    } else {
      myMoment = moment(date);
    }
    return myMoment.format("YYYY MMM DD");
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts